import { Section } from "./Section";
import { Reveal } from "./Reveal";
import { AssetImage } from "./AssetImage";
import { ASSETS, ECOSYSTEM } from "../../config/site";
import { Landmark, Presentation, Cog, Home } from "lucide-react";

const ICONS = { Landmark, Presentation, Cog, Home };

export const Ecosystem = () => (
  <Section
    id="ecosystem"
    className="bg-sand/50"
    overline="The ecosystem"
    title="More than land — a working support system"
    sub="Approvals, markets, machinery and manpower. The four things every factory needs, built into the estate itself."
  >
    <div className="grid gap-6 md:grid-cols-2">
      {ECOSYSTEM.map((e, i) => {
        const Icon = ICONS[e.icon];
        return (
          <Reveal key={e.key} delay={(i % 2) * 0.1}>
            <div
              className="group h-full overflow-hidden border border-border bg-paper-light"
              data-testid={`ecosystem-${e.key}`}
            >
              <div className="relative h-52 overflow-hidden sm:h-60">
                <AssetImage
                  asset={ASSETS[e.key]}
                  alt={e.title}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                  placeholderLabel={e.title}
                />
                <div className="absolute inset-x-0 bottom-0 h-16 bg-gradient-to-t from-forest-dark/60 to-transparent" />
                <div className="absolute bottom-3 left-4 flex items-center gap-2 text-paper">
                  <Icon className="h-5 w-5 text-gold" strokeWidth={1.5} />
                  <span className="text-xs uppercase tracking-[0.2em]">{e.title}</span>
                </div>
              </div>
              <div className="p-6">
                <h3 className="font-display text-2xl font-medium text-forest">{e.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-[#4A4C4A]">{e.desc}</p>
              </div>
            </div>
          </Reveal>
        );
      })}
    </div>
  </Section>
);
